import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import store from 'index';


class StructureMapping {
    
    static getConfig(configType) {
        if(store.getState().metadata.config) {
            const config = store.getState().metadata.config;
        
            switch(configType) {
                case Metadata.OBJECT_TYPE_CLIP:
                    return config.clip;
                case Metadata.OBJECT_TYPE_PROJECT:
                    return config.project;
                case Metadata.OBJECT_TYPE_ROOM:
                    return config.room;
                case Metadata.OBJECT_TYPE_DISTRIBUTION:
                    return config.distribution;
                case Metadata.OBJECT_TYPE_MEDIAFILE:
                    return config.mediafile;
                default:
                    return {};
            }
        }
        
        return {};
    }
    
    static createMassEditStructure(tabs, clips) {
        const config = StructureMapping.getConfig(Metadata.OBJECT_TYPE_CLIP);
        const structure = {};
        
        for(let i in config) {
            let obj = config[i];
            
            if(StructureMapping.isField(obj)) {
                // get tab and insert if not existing
                let tab = StructureMapping.getTab(obj);
                if(tabs.includes(tab)) {
                    let field = StructureMapping.getValue(obj, 'field');
                    let massedit = StructureMapping.isMassEditField(obj);
                    
                    switch(massedit) {
                        case "merge":
                            structure[field] = StructureMapping.createMassEditMerge(field, clips);
                            break;
                        default:
                            structure[field] = "";
                            break;
                    }
                }
            }
        }
        
        return structure;
    }
    
    static createMassEditMerge(field, clips) {
        let value = [];
        for(let clip of clips) {
            if(clip.metadata[field]) {
                let ids = clip.metadata[field].split(';');
                for(let id of ids) {
                    if(value.indexOf(id) === -1) {
                        value.push(id);
                    }
                }
            }
        }
        return value.join(';');
    }
    
    static createMassEditUnmerge(field, clips) {
        let value = [];
        for(let clip of clips) {
            if(clip.metadata[field]) {
                let ids = clip.metadata[field].split(';');
                for(let id of ids) {
                    if(value.indexOf(id) === -1) {
                        value.push(id);
                    }
                }
            }
        }
        return value.join(';');
    }
        
    static createTabStructure(configType) {
        const config = StructureMapping.getConfig(configType);
        const structure = {};
        
        for(let i in config) {
            let obj = config[i];
            
            if(StructureMapping.isField(obj)) {
                // get tab and insert if not existing
                let tab = StructureMapping.getTab(obj);
                if(!structure.hasOwnProperty(tab)) {
                    structure[tab] = [];
                }
                
                // push field to correct tab
                let field = StructureMapping.getValue(obj, 'field');
                structure[tab].push(field);
            }
        }
        
        return structure;
    }
    
    static createStructure(configType) {
        const config = StructureMapping.getConfig(configType);
        const structure = {};
        
        for(let i in config) {
            let obj = config[i];
            
            if(StructureMapping.isField(obj)) {
                // get tab and insert if not existing
                let tab = StructureMapping.getTab(obj);
                if(!structure.hasOwnProperty(tab)) {
                    structure[tab] = [];
                }
                
                // push obj to correct tab
                structure[tab].push(obj);
            }
        }
        
        for(let key in structure) {
            structure[key] = structure[key].sort(StructureMapping.sortByOrder);
        }
        
        return structure;
    }
    
    static createLangStructure(configType, langs) {
        const config = StructureMapping.getConfig(configType);
        const structure = {}; // default languages
        
        for(let key in langs) {
            structure[key] = [];
        }
        //structure.de = [];
        //structure.en = [];
        
        for(let i in config) {
            let obj = config[i];
            
            if(StructureMapping.isField(obj)) {
                let field = StructureMapping.getValue(obj, 'field');
                // get languages and insert if not existing
                let lang = StructureMapping.getLang(obj);
                
                // insert into all languages if no language is set
                if(!lang.length) {
                    for(let key in structure) {
                        structure[key].push(field);
                        
                    }
                } else {
                    // insert into defined language and create if language not exists
                    for(let i in lang) {
                        if(!structure.hasOwnProperty(lang[i])) {
                            structure[lang[i]] = [];
                        }
                        structure[lang[i]].push(field);
                    }
                }
            }
        }
        
        return structure;
    }
    
    static createCheckboxStructure(configType, elements) {
        const structure = {};
        
        for ( let key in elements ) {
            let obj = StructureMapping.getField(configType, key);
            if(obj !== null) {
                if(StructureMapping.getType(obj) === 'checkbox' || StructureMapping.getType(obj) === 'dropdown') {
                    // prevent null exception
                    const values = (elements[key] !== null) ? elements[key].split(';') : [];
                    const options = StructureMapping.getOptions(obj);
                    
                    structure[obj.field] = {};
                    for(let i in options) {
                        if(values.includes(i)) {
                            structure[obj.field][i] = true;
                        } else {
                            structure[obj.field][i] = false;
                        }
                    }
                } 
            }
        }
        
        return structure;
    }
    
    static getUsedElements(configType, elements, tabs) {
        const structure = {};
        
        for(let key in elements) {
            let obj = StructureMapping.getField(configType, key);
            
            if(obj) {
                let tab = StructureMapping.getTab(obj);
                
                if(tabs.includes(tab)) {
                    structure[key] = elements[key];
                }
            }
        }
        
        return structure;
    }
    
    static createRemoveStructure(configType, elements, tabs) {
        const structure = [];
        
        for(let key in elements) {
            let obj = StructureMapping.getField(configType, key);
            
            if(obj) {
                if(StructureMapping.isRemoveBeforeSave(obj)) {
                    structure.push(key);
                }
            }
        }
        
        return structure;
    }
    
    static noMappingElement(elements, configType) {
        const config = StructureMapping.getConfig(configType);
        
        for(let i in config) {
            let obj = config[i];
            if(StructureMapping.isData(obj)) {
                let field = StructureMapping.getValue(obj, 'field');
                if(!elements.hasOwnProperty(field)) {
                    console.log(field + " has no element!");
                }
            }
        }
    }
    
    static noMappingStructure(elements, configType) {
        for(let key in elements) {
            let obj = StructureMapping.getField(configType, key);
            if(!obj) {
                console.log(key + " has no structure!");
            }
        }
    }
    
    static notUsedInConfig(apiDef, configType) {
        const notUsed = [];
        apiDef[configType].forEach( key => {
            let obj = StructureMapping.getField(configType, key);
            if(!obj) {
                notUsed.push(key);
            }
        });
        
        return notUsed.sort();
    }
    
    static isField(obj) {
        if(!obj) {
            return false;
        }
        
        return StructureMapping.getValue(obj, 'field') !== null;
    }
    
    static getField(configType, field) {
        if(!field) {
            return null;
        }
        
        const config = StructureMapping.getConfig(configType);

        let obj;
        for ( let key in config ) {
            obj = config[key];
            if(obj.hasOwnProperty('field')) {
                if(obj.field === field) {
                   return obj;
                }
            }
        }
        return null;
    }

    static getValue(obj, field) {
        if(!obj || !field) {
            return null;
        }

        if(obj.hasOwnProperty(field)) {
            return obj[field];
        }

        return null;
    }

    static getType(obj) {
        return StructureMapping.getValue(obj, 'type');
    }
    
    static getTab(obj) {
        return StructureMapping.getValue(obj, 'tab');
    }
    
    static getLang(obj) {
        let lang = [];

        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('lang')) {
            lang = params.lang.split(';', 2);
        }
        
        return lang;
    }
    
    static getIntl(obj) {
        const intl = StructureMapping.getValue(obj, 'intl');
        return (intl) ? intl : "0";
    }
    
    static getOrder(obj) {
        const order = StructureMapping.getValue(obj, 'order');
        return (order) ? order : 0;
    }
    
    static sortByOrder(a, b) {
        if(a.order === 0 && b.order === 0) {
            return 0;
        }
        
        if(a.order === 0) {
            return 1;
        }
        
        if(b.order === 0) {
            return -1;
        }
        
        if(a.order > b.order) {
            return 1;
        }
        
        if(a.order < b.order) {
            return -1;
        }
        
        return 0;
    }

    static isReadonly(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('readonly')) {
            return params.readonly;
        }
        return false;
    }
    
    static isHidden(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('hidden')) {
            return params.hidden;
        }
        return false;
    }

    static isDatefield(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('datefield')) {
            return params.datefield;
        }
        return false;
    }
    
    static isTimefield(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('timefield')) {
            return params.timefield;
        }
        return false;
    }
    
    static isRemoveBeforeSave(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('removeBeforeSave')) {
            return params.removeBeforeSave;
        }
        return false;
    }
    
    static isMassEditField(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('massedit')) {
            return params.massedit;
        }
        return false;
    }
    
    static getOptions(obj) {
        let optionsArray = {};
        const options = StructureMapping.getValue(obj, 'options');
        if(options && options.length) {
            for(let i in options) {
                let value = options[i].split('=', 2);
                if(value.length === 2) {
                    optionsArray[value[0]] = value[1];   
                } else {
                    optionsArray[value[0]] = value[0];
                }
            }
        }
        return optionsArray;
    }
    
    static getUserList(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('userlist')) {
            return params.userlist;
        }
        return {};
    }
    
    static getTagTree(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('tagtree')) {
            return params.tagtree;
        }
        return "tags";
    }
    
    static getTagTreeReferenceIds(obj) {
        const params = StructureMapping.getValue(obj, 'params');
        if(params && params.hasOwnProperty('referenceIds') && params.referenceIds !== null) {
            return params.referenceIds;
        }
        
        return "";
    }
    
    // TODO: have a look on params - sepvalue
    static isSingleCheckbox(obj) {
        return (StructureMapping.getOptions(obj).length === 1);
    }
}

export default StructureMapping;
